import { stylesheet } from 'typestyle';

import { regularYellowText } from '@styles/general';

export const height = 71;

export default stylesheet({
  container: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    boxSizing: 'border-box',
    height: height,
    borderBottom: '1px solid #e9e9e9'
  },

  section: {
    flex: 1,
    background: '#f6f6f6',
    paddingLeft: 36,
    paddingRight: 10,

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    position: 'relative',
    cursor: 'pointer',

    $nest: {
      '&.active': {
        backgroundColor: '#21528d',
        color: 'white'
      },

      '@media (max-width: 479px)': {
        paddingLeft: 20
      },

      '@media (max-width: 374px)': {
        '&:first-child': {
          paddingLeft: 5
        }
      }
    }
  },

  sectionHeader: {
    color: '#7f7f7f',
    fontSize: 15,
    lineHeight: '16px',

    $nest: {
      '.active &': {
        color: 'white'
      }
    }
  },

  sectionCaption: {
    lineHeight: 1,
    color: regularYellowText,
    marginBottom: 0,

    '@media (max-width: 619px)': {
      display: 'none'
    },

    $nest: {
      '@media (max-width: 699px)': {
        '.empty &': {
          display: 'none'
        }
      }
    }
  },

  sectionPrice: {
    '@media (max-width: 739px)': {
      display: 'none'
    }
  },

  sectionPronoun: {
    '@media (max-width: 579px)': {
      display: 'none'
    }
  },

  specifications: {
    order: 1,
    marginLeft: 11,

    '@media (max-width: 374px)': {
      marginLeft: 5
    }
  },

  chooseText: {
    '@media (max-width: 659px)': {
      display: 'none'
    }
  },

  chooseAText: {
    '@media (max-width: 699px)': {
      display: 'none'
    }
  },

  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: 0,
    borderRadius: '50%',
    height: 28,
    width: 28,
    border: '1px solid #cccccc',
    background: '#fff',
    padding: 4,

    $nest: {
      '& > img': {
        maxWidth: 18,
        maxHeight: 18
      }
    }
  },

  blueChevron: {
    position: 'absolute',
    zIndex: 1,
    width: '0',
    height: '0',
    top: '0',
    right: '-15px',
    borderStyle: 'solid',
    borderWidth: '35px 0 35px 15px',
    borderColor: 'transparent transparent transparent #21528d'
  },

  greyChevron: {
    position: 'absolute',
    zIndex: 1,
    width: '0',
    height: '0',
    top: '0',
    right: '-15px',
    borderStyle: 'solid',
    borderWidth: '35px 0 35px 15px',
    borderColor: 'transparent transparent transparent #d4d3d3',
    $nest: {
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '0',
        height: '0',
        top: '-35px',
        left: '-16px',
        borderStyle: 'solid',
        borderWidth: '35px 0 35px 15px',
        borderColor: 'transparent transparent transparent #f6f6f6'
      }
    }
  }
});
